import React from "react";

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, message }) => {
  if (!isOpen) return null;

  const modalOverlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  };

  const modalContentStyle = {
    background: "white",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    maxWidth: "400px",
    textAlign: "center",
  };

  const ConfirmButtonStyle = {
   marginRight: "15px", padding: "10px 15px", width: "auto" ,
            backgroundColor: "#07b1b0",color:"#fff",border:"none",borderRadius: "4px",
            cursor: "pointer",
  };

  const closeButtonStyle = {
    padding: "10px 15px",
            width: "auto",
            backgroundColor: "#fff",
            border:"1px solid #07b1b0",
            color:"#07b1b0",borderRadius: "4px",
            cursor: "pointer",
  };

  const modalPara = {
    textAlign: "left",
  };

  return (
    <div style={modalOverlayStyle}>
      <div style={modalContentStyle}>
        <p style={modalPara}>{message || "Are you sure you want to delete?"}</p>
        <div className="actions">
          <button onClick={onConfirm} style={ConfirmButtonStyle}>Yes</button>
          <button onClick={onClose} style={closeButtonStyle}>No</button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
